import React, { Component } from "react";
import { MDBInput, MDBTextArea, MDBBtn, MDBSwitch } from "mdb-react-ui-kit";
import { MfmImageUploader } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmImageUploader/MfmImageUploader";
import { mfmOriginalUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";
import TeaserVideoPlayer from "../../Common/TeaserVideoPlayer";
import {
  parseTeaserConfig,
  serializeTeaserConfig,
  normalizeTeaserConfig,
} from "../../Common/videoTeaserConfig";
import ModalPortal from "./ModalPortal";
import "./VideoItemModal.css";

export default class VideoItemModal extends Component {
  constructor(props) {
    super(props);
    const incoming = props.item || {};
    const teaserConfig = parseTeaserConfig(incoming.teaserConfigJson);
    this.state = {
      item: {
        idVideo: incoming.idVideo ?? null,
        title: incoming.title || "",
        description: incoming.description || "",
        fileUrl: incoming.fileUrl || "",
        videoUuid: incoming.videoUuid || null,
        externalId: incoming.externalId || "",
        teaserConfigJson: incoming.teaserConfigJson || null,
      },
      teaserConfig,
    };
    this.mfmRef = React.createRef();
  }

  componentDidMount() {
    document.body.classList.add("modal-open");
  }
  componentWillUnmount() {
    document.body.classList.remove("modal-open");
  }

  componentDidUpdate(prevProps) {
    if (prevProps.item !== this.props.item) {
      const incoming = this.props.item || {};
      const normalizedSrc = incoming.fileUrl || "";
      const teaserConfig = parseTeaserConfig(incoming.teaserConfigJson);
      this.setState({
        item: {
          idVideo: incoming.idVideo ?? null,
          title: incoming.title || "",
          description: incoming.description || "",
          fileUrl: normalizedSrc,
          videoUuid: incoming.videoUuid || null,
          externalId: incoming.externalId || "",
          teaserConfigJson: incoming.teaserConfigJson || null,
        },
        teaserConfig,
      });
    }
  }

  onField = (k, v) => this.setState((s) => ({ item: { ...s.item, [k]: v } }));

  onTeaserMode = (mode) => {
    this.setState((s) => ({
      teaserConfig: normalizeTeaserConfig({ ...s.teaserConfig, mode }),
    }));
  };

  onClipField = (key, value) => {
    const n = Number(value);
    this.setState((s) => ({
      teaserConfig: normalizeTeaserConfig({
        ...s.teaserConfig,
        clip: { ...s.teaserConfig.clip, [key]: Number.isFinite(n) ? n : 0 },
      }),
    }));
  };

  onAdvancedField = (key, value) => {
    this.setState((s) => ({
      teaserConfig: normalizeTeaserConfig({
        ...s.teaserConfig,
        advanced: { ...s.teaserConfig.advanced, [key]: value },
      }),
    }));
  };

  onTransitionField = (key, value) => {
    this.setState((s) => ({
      teaserConfig: normalizeTeaserConfig({
        ...s.teaserConfig,
        advanced: {
          ...s.teaserConfig.advanced,
          transition: {
            ...s.teaserConfig.advanced.transition,
            [key]: value,
          },
        },
      }),
    }));
  };

  addSegment = () => {
    this.setState((s) => {
      const segments = s.teaserConfig.advanced.segments || [];
      const last = segments[segments.length - 1] || { startSec: 0, endSec: 5 };
      const next = {
        startSec: Number(last.endSec) || 0,
        endSec: (Number(last.endSec) || 0) + 5,
      };
      return {
        teaserConfig: normalizeTeaserConfig({
          ...s.teaserConfig,
          advanced: {
            ...s.teaserConfig.advanced,
            segments: [...segments, next],
          },
        }),
      };
    });
  };

  removeSegment = (idx) => {
    this.setState((s) => {
      const segments = (s.teaserConfig.advanced.segments || []).slice();
      segments.splice(idx, 1);
      return {
        teaserConfig: normalizeTeaserConfig({
          ...s.teaserConfig,
          advanced: {
            ...s.teaserConfig.advanced,
            segments,
          },
        }),
      };
    });
  };

  onSegmentField = (idx, key, value) => {
    const n = Number(value);
    this.setState((s) => {
      const segments = (s.teaserConfig.advanced.segments || []).slice();
      if (!segments[idx]) return null;
      segments[idx] = {
        ...segments[idx],
        [key]: Number.isFinite(n) ? n : 0,
      };
      return {
        teaserConfig: normalizeTeaserConfig({
          ...s.teaserConfig,
          advanced: {
            ...s.teaserConfig.advanced,
            segments,
          },
        }),
      };
    });
  };

  buildSaveItem = () => {
    const { item, teaserConfig } = this.state;
    return {
      ...item,
      teaserConfigJson: serializeTeaserConfig(teaserConfig),
    };
  };

  handleVideoUpload = (result) => {
    if (!result?.uuid) return;
    const resolvedUrl = mfmOriginalUrl(result.uuid);
    this.setState((s) => ({
      item: {
        ...s.item,
        videoUuid: result.uuid,
        fileUrl: resolvedUrl,
      },
    }));
  };

  clearVideoUpload = () => {
    this.setState((s) => ({
      item: {
        ...s.item,
        videoUuid: null,
      },
    }));
  };

  render() {
    const { onClose, onSave, onDelete } = this.props;
    const { item, teaserConfig } = this.state;
    const previewTeaserJson = serializeTeaserConfig(teaserConfig);

    return (
      <ModalPortal>
        <div className="modal-overlay" onClick={onClose}>
          <div className="modal-card detail-modal-card" onClick={(e) => e.stopPropagation()}>
            {/* Header (igual que el modal público) */}
            <div className="d-flex justify-content-between align-items-center detail-modal-header">
              <h5 className="detail-modal-title mb-0">Editar vídeo</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Cerrar" />
            </div>

            <div className="detail-modal-body">
              {/* Preview del vídeo 16:9 */}
              <div className="detail-modal-video">
                <TeaserVideoPlayer
                  src={item.fileUrl}
                  teaserConfigJson={previewTeaserJson}
                  controls
                  width="100%"
                  height="100%"
                  style={{ position: "absolute", top: 0, left: 0 }}
                />
              </div>

              {/* Campos editables */}
              <div className="detail-modal-section">
                <MDBInput
                  label="Título"
                  className="mb-3"
                  value={item.title}
                  onChange={(e) => this.onField("title", e.target.value)}
                />
                <MDBTextArea
                  label="Descripción"
                  rows={3}
                  className="mb-3"
                  value={item.description}
                  onChange={(e) => this.onField("description", e.target.value)}
                />
                <MDBInput
                  label="URL del vídeo (YouTube/Vimeo/archivo)"
                  className="mb-2"
                  value={item.fileUrl}
                  onChange={(e) =>
                    this.setState((s) => ({
                      item: {
                        ...s.item,
                        fileUrl: e.target.value,
                        videoUuid: null,
                      },
                    }))
                  }
                />
                <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                  <MDBBtn
                    size="sm"
                    color="secondary"
                    outline
                    type="button"
                    onClick={() => this.mfmRef.current?.openModal()}
                  >
                    Subir/seleccionar desde MFM
                  </MDBBtn>
                  {item.videoUuid && (
                    <>
                      <span className="small text-muted">UUID: {item.videoUuid}</span>
                      <MDBBtn
                        size="sm"
                        color="danger"
                        outline
                        type="button"
                        onClick={this.clearVideoUpload}
                      >
                        Quitar MFM
                      </MDBBtn>
                    </>
                  )}
                </div>
                <MDBInput
                  label="External ID (solo lectura)"
                  className="mb-1"
                  value={item.externalId}
                  readOnly
                  disabled
                />
                <div className="vim-helper">
                  * El External ID se calcula automáticamente en el servidor.
                </div>

                <div className="vim-teaser-block mt-3">
                  <h6 className="vim-subtitle">Teaser / Fragmentos</h6>
                  <div className="vim-row-2">
                    <label className="form-label mb-1">Modo de reproducción</label>
                    <select
                      className="form-select form-select-sm"
                      value={teaserConfig.mode}
                      onChange={(e) => this.onTeaserMode(e.target.value)}
                    >
                      <option value="full">Vídeo completo</option>
                      <option value="clip">Fragmento único</option>
                      <option value="advanced">Modo avanzado (playlist de fragmentos)</option>
                    </select>
                  </div>

                  {teaserConfig.mode === "clip" && (
                    <div className="vim-clip-grid">
                      <MDBInput
                        type="number"
                        label="Inicio (seg)"
                        min={0}
                        step={0.1}
                        value={teaserConfig.clip.startSec}
                        onChange={(e) => this.onClipField("startSec", e.target.value)}
                      />
                      <MDBInput
                        type="number"
                        label="Fin (seg)"
                        min={0}
                        step={0.1}
                        value={teaserConfig.clip.endSec}
                        onChange={(e) => this.onClipField("endSec", e.target.value)}
                      />
                    </div>
                  )}

                  {teaserConfig.mode === "advanced" && (
                    <div className="vim-advanced-block">
                      <div className="vim-advanced-options">
                        <div>
                          <label className="form-label mb-1">Orden</label>
                          <select
                            className="form-select form-select-sm"
                            value={teaserConfig.advanced.order}
                            onChange={(e) => this.onAdvancedField("order", e.target.value)}
                          >
                            <option value="sequence">Secuencial</option>
                            <option value="random">Aleatorio</option>
                          </select>
                        </div>
                        <div>
                          <label className="form-label mb-1">Transición</label>
                          <select
                            className="form-select form-select-sm"
                            value={teaserConfig.advanced.transition.type}
                            onChange={(e) => this.onTransitionField("type", e.target.value)}
                          >
                            <option value="none">Sin transición</option>
                            <option value="fade">Fundido</option>
                          </select>
                        </div>
                        <MDBInput
                          type="number"
                          label="Duración transición (ms)"
                          min={0}
                          step={50}
                          value={teaserConfig.advanced.transition.durationMs}
                          onChange={(e) =>
                            this.onTransitionField(
                              "durationMs",
                              Number(e.target.value) || 0
                            )
                          }
                        />
                      </div>

                      <div className="vim-switch-row">
                        <MDBSwitch
                          id="vim-loop"
                          checked={teaserConfig.advanced.loop}
                          onChange={(e) => this.onAdvancedField("loop", e.target.checked)}
                          label="Repetición infinita"
                        />
                        <MDBSwitch
                          id="vim-repeat"
                          checked={teaserConfig.advanced.allowRepeat}
                          onChange={(e) =>
                            this.onAdvancedField("allowRepeat", e.target.checked)
                          }
                          label="Permitir repetición de fragmentos"
                          disabled={teaserConfig.advanced.order !== "random"}
                        />
                      </div>

                      <div className="vim-segments-list">
                        {(teaserConfig.advanced.segments || []).map((seg, idx) => (
                          <div className="vim-segment-row" key={`seg-${idx}`}>
                            <div className="vim-segment-index">#{idx + 1}</div>
                            <MDBInput
                              type="number"
                              label="Inicio"
                              min={0}
                              step={0.1}
                              value={seg.startSec}
                              onChange={(e) =>
                                this.onSegmentField(idx, "startSec", e.target.value)
                              }
                            />
                            <MDBInput
                              type="number"
                              label="Fin"
                              min={0}
                              step={0.1}
                              value={seg.endSec}
                              onChange={(e) =>
                                this.onSegmentField(idx, "endSec", e.target.value)
                              }
                            />
                            <MDBBtn
                              size="sm"
                              color="danger"
                              outline
                              type="button"
                              onClick={() => this.removeSegment(idx)}
                            >
                              Quitar
                            </MDBBtn>
                          </div>
                        ))}
                      </div>

                      <MDBBtn
                        size="sm"
                        color="secondary"
                        outline
                        type="button"
                        onClick={this.addSegment}
                      >
                        Añadir fragmento
                      </MDBBtn>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <MfmImageUploader
              ref={this.mfmRef}
              headless
              appCode="TEAN"
              library="videos"
              mediaType="video"
              onUpload={this.handleVideoUpload}
            />

            {/* Acciones */}
            <div className="vim-actions d-flex align-items-center">
              {onDelete && (
                <MDBBtn color="danger" outline onClick={onDelete}>
                  Eliminar
                </MDBBtn>
              )}
              <div style={{ flex: 1 }} />
              <MDBBtn color="secondary" onClick={onClose}>
                Cancelar
              </MDBBtn>
              <MDBBtn
                className="tean-btn-primary"
                onClick={() => onSave && onSave(this.buildSaveItem())}
              >
                Guardar
              </MDBBtn>
            </div>
          </div>
        </div>
      </ModalPortal>
    );
  }
}
